import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import { MinMaxSearchCard } from './MinMaxSearchCard';
import { MinMaxSelectSearchCard } from './MinMaxSelectSearchCard';


export const EffectsSearchCard = ({
  children,
  peopleDescriptors,
  model,
  damageDescriptors,
  total,
  deaths,
  damage,
  injuries,
  housedDestroyed,
  housesDescriptors,
  minDeathsField,
  minTotalDeathsField,
  minDamageField,
  minTotalDamageField,
  minInjuriesField,
  minTotalInjuriesField,
  minHousesDestroyedField,
  minTotalHousesDestroyedField,
  minDeathsDescField,
  minTotalDeathsDescField,
  minDamageDescField,
  minTotalDamageDescField,
  minInjuriesDescField,
  minTotalInjuriesDescField,
  minHousesDestroyedDescField,
  minTotalHousesDestroyedDescField,
  maxDeathsField,
  maxTotalDeathsField,
  maxDamageField,
  maxTotalDamageField,
  maxInjuriesField,
  maxTotalInjuriesField,
  maxHousesDestroyedField,
  maxTotalHousesDestroyedField,
  maxDeathsDescField,
  maxTotalDeathsDescField,
  maxDamageDescField,
  maxTotalDamageDescField,
  maxInjuriesDescField,
  maxTotalInjuriesDescField,
  maxHousesDestroyedDescField,
  maxTotalHousesDestroyedDescField,
  minHousesDamagedField,
  minTotalHousesDamagedField,
  maxHousesDamagedField,
  maxTotalHousesDamagedField,
  minHousesDamagedDescField,
  minTotalHousesDamagedDescField,
  maxHousesDamagedDescField,
  maxTotalHousesDamagedDescField,
  housedDamaged,
  helpModalIdPrefix,
}) => (
  <Card>
    <CardBody>
      <CardTitle tag="h2">{children}</CardTitle>

      { deaths && (
      <div className="form-row row-margin-fix">
        <MinMaxSearchCard
          className="col-lg-4"
          min={total ? minTotalDeathsField : minDeathsField}
          max={total ? maxTotalDeathsField : maxDeathsField}
          helpModalId={total ? `${helpModalIdPrefix}TotalDeaths` : `${helpModalIdPrefix}Deaths`}
        >
          {total ? 'Total Deaths' : 'Deaths'}
        </MinMaxSearchCard>
        <MinMaxSelectSearchCard
          className="col-lg-8"
          model={model}
          minField={total ? minTotalDeathsDescField : minDeathsDescField}
          maxField={total ? maxTotalDeathsDescField : maxDeathsDescField}
          descriptors={peopleDescriptors}
          helpModalId={total ? `${helpModalIdPrefix}TotalDeathsDescription` : `${helpModalIdPrefix}DeathsDescription`}
          prependId
        >
          {total ? 'Total Deaths Description' : 'Deaths Description'}
        </MinMaxSelectSearchCard>
      </div>
      )}

      { injuries && (
      <div className="form-row row-margin-fix">
        <MinMaxSearchCard
          className="col-lg-4"
          min={total ? minTotalInjuriesField : minInjuriesField}
          max={total ? maxTotalInjuriesField : maxInjuriesField}
          helpModalId={total ? `${helpModalIdPrefix}TotalInjuries` : `${helpModalIdPrefix}Injuries`}
        >
          {total ? 'Total Injuries' : 'Injuries'}
        </MinMaxSearchCard>
        <MinMaxSelectSearchCard
          className="col-lg-8"
          model={model}
          minField={total ? minTotalInjuriesDescField : minInjuriesDescField}
          maxField={total ? maxTotalInjuriesDescField : maxInjuriesDescField}
          descriptors={peopleDescriptors}
          prependId
          helpModalId={total ? `${helpModalIdPrefix}TotalInjuriesDescription` : `${helpModalIdPrefix}InjuriesDescription`}
        >
          {total ? 'Total Injuries Description' : 'Injuries Description'}
        </MinMaxSelectSearchCard>
      </div>
      )}

      { damage && (
      <div className="form-row row-margin-fix">
        <MinMaxSearchCard
          className="col-lg-4"
          min={total ? minTotalDamageField : minDamageField}
          max={total ? maxTotalDamageField : maxDamageField}
          helpModalId={total ? `${helpModalIdPrefix}TotalDamage` : `${helpModalIdPrefix}Damage`}
        >
          Damage ($Mil)
        </MinMaxSearchCard>
        <MinMaxSelectSearchCard
          className="col-lg-8"
          model={model}
          minField={total ? minTotalDamageDescField : minDamageDescField}
          maxField={total ? maxTotalDamageDescField : maxDamageDescField}
          descriptors={damageDescriptors}
          prependId
          helpModalId={total ? `${helpModalIdPrefix}TotalDamageDescription` : `${helpModalIdPrefix}DamageDescription`}
        >
          {total ? 'Total Damage Description' : 'Damage Description'}
        </MinMaxSelectSearchCard>
      </div>
      )}

      { housedDestroyed && (
      <div className="form-row row-margin-fix">
        <MinMaxSearchCard
          className="col-lg-4"
          min={total ? minTotalHousesDestroyedField : minHousesDestroyedField}
          max={total ? maxTotalHousesDestroyedField : maxHousesDestroyedField}
          helpModalId={total ? `${helpModalIdPrefix}TotalHousesDestroyed` : `${helpModalIdPrefix}HousesDestroyed`}
        >
          {total ? 'Total Houses Destroyed' : 'Houses Destroyed'}
        </MinMaxSearchCard>
        <MinMaxSelectSearchCard
          className="col-lg-8"
          model={model}
          minField={total ? minTotalHousesDestroyedDescField : minHousesDestroyedDescField}
          maxField={total ? maxTotalHousesDestroyedDescField : maxHousesDestroyedDescField}
          descriptors={housesDescriptors}
          prependId
          helpModalId={total ? `${helpModalIdPrefix}TotalHousesDestroyedDescription` : `${helpModalIdPrefix}HousesDestroyedDescription`}
        >
          {total ? 'Total Houses Destroyed Description' : 'Houses Destroyed Description'}
        </MinMaxSelectSearchCard>
      </div>
      )}

      { housedDamaged && (
      <div className="form-row row-margin-fix">
        <MinMaxSearchCard
          className="col-lg-4"
          min={total ? minTotalHousesDamagedField : minHousesDamagedField}
          max={total ? maxTotalHousesDamagedField : maxHousesDamagedField}
          helpModalId={total ? `${helpModalIdPrefix}TotalHousesDamaged` : `${helpModalIdPrefix}HousesDamaged`}
        >
          {total ? 'Total Houses Damaged' : 'Houses Damaged'}
        </MinMaxSearchCard>
        <MinMaxSelectSearchCard
          className="col-lg-8"
          model={model}
          minField={total ? minTotalHousesDamagedDescField : minHousesDamagedDescField}
          maxField={total ? maxTotalHousesDamagedDescField : maxHousesDamagedDescField}
          descriptors={housesDescriptors}
          prependId
          helpModalId={total ? `${helpModalIdPrefix}TotalHousesDamagedDescription` : `${helpModalIdPrefix}HousesDamagedDescription`}
        >
          {total ? 'Total Houses Damaged Description' : 'Houses Damaged Description'}
        </MinMaxSelectSearchCard>
      </div>
      )}

    </CardBody>
  </Card>
);

EffectsSearchCard.propTypes = {
  children: PropTypes.node.isRequired,
  total: PropTypes.bool,
  model: PropTypes.string.isRequired,
  peopleDescriptors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
  damageDescriptors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
  housesDescriptors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
  deaths: PropTypes.bool,
  damage: PropTypes.bool,
  injuries: PropTypes.bool,
  housedDestroyed: PropTypes.bool,
  housedDamaged: PropTypes.bool,
  minDeathsField: PropTypes.string,
  minTotalDeathsField: PropTypes.string,
  minDamageField: PropTypes.string,
  minTotalDamageField: PropTypes.string,
  minInjuriesField: PropTypes.string,
  minTotalInjuriesField: PropTypes.string,
  minHousesDestroyedField: PropTypes.string,
  minTotalHousesDestroyedField: PropTypes.string,
  minDeathsDescField: PropTypes.string,
  minTotalDeathsDescField: PropTypes.string,
  minDamageDescField: PropTypes.string,
  minTotalDamageDescField: PropTypes.string,
  minInjuriesDescField: PropTypes.string,
  minTotalInjuriesDescField: PropTypes.string,
  minHousesDestroyedDescField: PropTypes.string,
  minTotalHousesDestroyedDescField: PropTypes.string,
  maxDeathsField: PropTypes.string,
  maxTotalDeathsField: PropTypes.string,
  maxDamageField: PropTypes.string,
  maxTotalDamageField: PropTypes.string,
  maxInjuriesField: PropTypes.string,
  maxTotalInjuriesField: PropTypes.string,
  maxHousesDestroyedField: PropTypes.string,
  maxTotalHousesDestroyedField: PropTypes.string,
  maxDeathsDescField: PropTypes.string,
  maxTotalDeathsDescField: PropTypes.string,
  maxDamageDescField: PropTypes.string,
  maxTotalDamageDescField: PropTypes.string,
  maxInjuriesDescField: PropTypes.string,
  maxTotalInjuriesDescField: PropTypes.string,
  maxHousesDestroyedDescField: PropTypes.string,
  maxTotalHousesDestroyedDescField: PropTypes.string,
  minHousesDamagedField: PropTypes.string,
  minTotalHousesDamagedField: PropTypes.string,
  maxHousesDamagedField: PropTypes.string,
  maxTotalHousesDamagedField: PropTypes.string,
  minHousesDamagedDescField: PropTypes.string,
  minTotalHousesDamagedDescField: PropTypes.string,
  maxHousesDamagedDescField: PropTypes.string,
  maxTotalHousesDamagedDescField: PropTypes.string,
  helpModalIdPrefix: PropTypes.string.isRequired,
};

EffectsSearchCard.defaultProps = {
  total: false,
  deaths: false,
  damage: false,
  injuries: false,
  housedDestroyed: false,
  housedDamaged: false,
  peopleDescriptors: [],
  damageDescriptors: [],
  housesDescriptors: [],
  minDeathsField: '.minDeaths',
  minTotalDeathsField: '.minDeathsTotal',
  minDamageField: '.minDamageMillionsDollars',
  minTotalDamageField: '.minDamageMillionsDollarsTotal',
  minInjuriesField: '.minInjuries',
  minTotalInjuriesField: '.minInjuriesTotal',
  minHousesDestroyedField: '.minHousesDestroyed',
  minTotalHousesDestroyedField: '.minHousesDestroyedTotal',
  minDeathsDescField: 'minDeathsAmountOrder',
  minTotalDeathsDescField: 'minDeathsAmountOrderTotal',
  minDamageDescField: 'minDamageAmountOrder',
  minTotalDamageDescField: 'minDamageAmountOrderTotal',
  minInjuriesDescField: 'minInjuriesAmountOrder',
  minTotalInjuriesDescField: 'minInjuriesAmountOrderTotal',
  minHousesDestroyedDescField: 'minHousesDestroyedAmountOrder',
  minTotalHousesDestroyedDescField: 'minHousesDestroyedAmountOrderTotal',
  maxDeathsField: '.maxDeaths',
  maxTotalDeathsField: '.maxDeathsTotal',
  maxDamageField: '.maxDamageMillionsDollars',
  maxTotalDamageField: '.maxDamageMillionsDollarsTotal',
  maxInjuriesField: '.maxInjuries',
  maxTotalInjuriesField: '.maxInjuriesTotal',
  maxHousesDestroyedField: '.maxHousesDestroyed',
  maxTotalHousesDestroyedField: '.maxHousesDestroyedTotal',
  maxDeathsDescField: 'maxDeathsAmountOrder',
  maxTotalDeathsDescField: 'maxDeathsAmountOrderTotal',
  maxDamageDescField: 'maxDamageAmountOrder',
  maxTotalDamageDescField: 'maxDamageAmountOrderTotal',
  maxInjuriesDescField: 'maxInjuriesAmountOrder',
  maxTotalInjuriesDescField: 'maxInjuriesAmountOrderTotal',
  maxHousesDestroyedDescField: 'maxHousesDestroyedAmountOrder',
  maxTotalHousesDestroyedDescField: 'maxHousesDestroyedAmountOrderTotal',
  minHousesDamagedField: '.minHousesDamaged',
  minTotalHousesDamagedField: '.minHousesDamagedTotal',
  maxHousesDamagedField: '.maxHousesDamaged',
  maxTotalHousesDamagedField: '.maxHousesDamagedTotal',
  minHousesDamagedDescField: 'minHousesDamagedAmountOrder',
  minTotalHousesDamagedDescField: 'minHousesDamagedAmountOrderTotal',
  maxHousesDamagedDescField: 'maxHousesDamagedAmountOrder',
  maxTotalHousesDamagedDescField: 'maxHousesDamagedAmountOrderTotal',
};
